import PropTypes from 'prop-types'

import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

const AgencyDetails = (props) => {
  const { agencyFormPayload } = props || {}
  const {
    entityState: {
      business_name,
      business_number,
      short_name,
      title,
    },
    errors,
    handlers,
  } = agencyFormPayload

  return (
    <DashboardModule title="Agency Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.title} label="* Title">
            <input
              name="title"
              value={title}
              type="text"
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Short Name" marginTop={['large', 0]}>
            <input
              name="short_name"
              value={short_name}
              type="text"
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Business Name">
            <input
              name="business_name"
              value={business_name}
              type="text"
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Business Number" marginTop={['large', 0]}>
            <input
              name="business_number"
              value={business_number}
              type="text"
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

AgencyDetails.propTypes = {
  agencyFormPayload: PropTypes.shape({
    entityState: PropTypes.shape({
      business_name: PropTypes.string.isRequired,
      business_number: PropTypes.string.isRequired,
      short_name: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
    errors: PropTypes.object,
    handlers: PropTypes.object.isRequired,
  }).isRequired,
}

export default AgencyDetails
